import { render, staticRenderFns } from "./showIdeaProjectsSchoolsStand.vue?vue&type=template&id=4e815228&scoped=true"
import script from "./showIdeaProjectsSchoolsStand.vue?vue&type=script&lang=js"
export * from "./showIdeaProjectsSchoolsStand.vue?vue&type=script&lang=js"
import style0 from "./showIdeaProjectsSchoolsStand.vue?vue&type=style&index=0&id=4e815228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e815228",
  null
  
)

export default component.exports